import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Agency from '../../interfaces/agency';

interface AgencyState {
    agencies: Agency[],
}

const initialState: AgencyState = {
    agencies: []
}

export const agencySlice = createSlice({
    name: 'agencies',
    initialState,
    reducers: {
        loadAgencies: (state, action: PayloadAction<Agency[]>) => {
            state.agencies = action.payload
        }
    }
});

export const {loadAgencies} = agencySlice.actions;

export default agencySlice.reducer;